var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.81 11.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.45px;}.b{fill:#009245;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.36,11.08a1.16,1.16,0,0,0,1-.68,6,6,0,0,0,.53-1.61,3.23,3.23,0,0,1,.35-1.36c.51-1,.37-2.93-.38-5-1-2.76-1.57-2.91-2.61-.67S-.07,6.36.54,7.55A3.4,3.4,0,0,1,.82,8.86,4.13,4.13,0,0,0,1,10.07l.22.48C1.45,11,1.77,11.07,2.36,11.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.56,6.9C.22,5.74.5,4.23,1.42,2.18,2.17.51,2.23.45,2.6.56c.85.25,2,4.31,1.69,6-.16,1-.41,1.28-1.16,1.09a3.31,3.31,0,0,0-1.37,0,7.78,7.78,0,0,1-.86.1A3,3,0,0,1,.56,6.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbOn);
export default __webpack_public_path__ + "static/media/bulbOn.91476f483044d9242730e6b60316dce4.svg";
export { ForwardRef as ReactComponent };